import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';


const SearchBar = ({ value, onChange, onSearch }) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [recentSearches] = useState([
    'E-commerce template',
    'Portfolio design',
    'Landing page',
    'Business website'
  ]);
  const searchRef = useRef(null);

  const suggestions = [
    { text: 'Modern portfolio template', icon: 'Briefcase' },
    { text: 'E-commerce store builder', icon: 'ShoppingCart' },
    { text: 'Landing page design', icon: 'Layout' },
    { text: 'Blog template responsive', icon: 'BookOpen' },
    { text: 'Business website starter', icon: 'Building' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef?.current && !searchRef?.current?.contains(event?.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    onChange(e?.target?.value);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (text) => {
    onChange(text);
    setShowSuggestions(false);
    if (onSearch) onSearch(text);
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && onSearch) {
      onSearch(value);
      setShowSuggestions(false);
    }
  };

  const filteredSuggestions = value
    ? suggestions?.filter(s => s?.text?.toLowerCase()?.includes(value?.toLowerCase()))
    : suggestions;

  return (
    <div ref={searchRef} className="relative w-full">
      <div className="relative">
        <Icon
          name="Search"
          size={20}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
        />
        <input
          type="text"
          value={value}
          onChange={handleInputChange}
          onFocus={() => setShowSuggestions(true)}
          onKeyPress={handleKeyPress}
          placeholder="Search templates by name, category, or features..."
          className="w-full pl-12 pr-12 py-3 md:py-4 bg-background border border-border rounded-xl text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all duration-250"
        />
        {value && (
          <button
            onClick={() => {
              onChange('');
              setShowSuggestions(false);
            }}
            className="absolute right-4 top-1/2 -translate-y-1/2 p-1 rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground transition-all duration-250"
            aria-label="Clear search"
          >
            <Icon name="X" size={18} />
          </button>
        )}
      </div>
      {showSuggestions && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-popover border border-border rounded-xl shadow-lg overflow-hidden z-50">
          {value && filteredSuggestions?.length > 0 && (
            <div className="p-2">
              <div className="caption font-medium text-muted-foreground px-3 py-2">
                Suggestions
              </div>
              {filteredSuggestions?.map((suggestion, index) => (
                <button
                  key={index}
                  onClick={() => handleSuggestionClick(suggestion?.text)}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-muted transition-all duration-250 text-left"
                >
                  <Icon name={suggestion?.icon} size={16} className="text-primary flex-shrink-0" />
                  <span className="text-sm text-foreground">{suggestion?.text}</span>
                </button>
              ))}
            </div>
          )}

          {!value && recentSearches?.length > 0 && (
            <div className="p-2 border-t border-border">
              <div className="caption font-medium text-muted-foreground px-3 py-2">
                Recent Searches
              </div>
              {recentSearches?.map((search, index) => (
                <button
                  key={index}
                  onClick={() => handleSuggestionClick(search)}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-muted transition-all duration-250 text-left"
                >
                  <Icon name="Clock" size={16} className="text-muted-foreground flex-shrink-0" />
                  <span className="text-sm text-foreground">{search}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;